import React, { useEffect, useRef, useState } from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { ChartFilter } from '../../Components/ChartFilter';
import { colorCode, handleValidateCodevalue, DEFAULT_CHART_DATE_RANGE_DAYS } from '../../Utility/constant';
import { handleRequestGetInvoice, handleRequestGetLead, handleRequestGetOrder } from '../../Store/dashboard/action';
import { useDispatch, useSelector } from 'react-redux';
import qs from 'qs';
import LoaderIcon from '../../Assets/images/loader.svg';
import { buildChartQueryParams } from '../../Utility/ownerUtils';
import { useDashboardUserScope } from '../../Utility/hooks/useDashboardUserScope';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);


const data = {
  labels: [],
  datasets: [
    {
      label: 'Leads',
      data: [],
      backgroundColor: colorCode[0],
    },
    {
      label: 'Order',
      data: [],
      backgroundColor: colorCode[1],
    },
    {
      label: 'Invoices',
      data: [],
      backgroundColor: colorCode[2],
    },
  ],
};



export function SourceLeadChart({internationalise, isParentLoading}) {

  const [value, setValue] = useState(DEFAULT_CHART_DATE_RANGE_DAYS);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [chartDataset, setChartDataset] = useState(data);

  const {
      currentUser,
      ownerlist,
      myTeam,
      resolvedOwners,
      getQueryOwnerIds
  } = useDashboardUserScope();

  const leadData = useSelector(state => state?.chart?.lead);
  const orderData = useSelector(state => state?.chart?.order);
  const invoiceData = useSelector(state => state?.chart?.invoice);
  
  const isFirstRender = useRef(true);


  const onChange = (e, isType) => {
        const {value} = e.target;
        setValue(value);
  }

  const handleGenearteRepprt = (userRes, leadRes, invoiceRes, orderRes ) => {
      return (userRes  || []).map(user => {
        const leadCount = (leadRes  || []).filter(l => l.ownerId === user.id).length;
        const orderCount = (orderRes  || []).filter(o => o.ownerId === user.id).length;
        const invoiceCount = (invoiceRes  || []).filter(i => i.ownerId === user.id).length;

        return {
          username: `${user.firstName} ${user.lastName}`,
          totalLeads: leadCount,
          totalOrders: orderCount,
          totalInvoices: invoiceCount
        };
      });
  }

  useEffect(() => {
    const reports = handleGenearteRepprt(
        resolvedOwners,
        leadData,
        invoiceData,
        orderData
    );
    
    const dataset = {
        labels: reports?.map(item => item?.username),
        datasets: [
          {
            label: handleValidateCodevalue(internationalise,"LEAD_SIDEBAR_MENU"),
            data: reports?.map(item => item?.totalLeads),
            backgroundColor: colorCode[0],
          },
          {
            label: handleValidateCodevalue(internationalise,"SALES_ORDER_SIDEBAR_MENU"),
            data: reports?.map(item => item?.totalOrders),
            backgroundColor: colorCode[1],
          },
          {
            label: handleValidateCodevalue(internationalise,"INVOICE_SIDEBAR_MENU"),
            data: reports?.map(item => item?.totalInvoices),
            backgroundColor: colorCode[2],
          },
        ],
    };
    setChartDataset(dataset);
  }, [leadData, orderData, invoiceData, resolvedOwners]);

  useEffect(() => {
    
  const fetchData = async () => {
    setIsLoading(true);

    const leadqueryparam = buildChartQueryParams(getQueryOwnerIds('lead'), value);
    const orderqueryparam = buildChartQueryParams(getQueryOwnerIds('order'), value);
    const invoicequeryparam = buildChartQueryParams(getQueryOwnerIds('invoice'), value);

    try {
      const [leadRes, invoiceRes, orderRes] = await Promise.all([
        dispatch(handleRequestGetLead({params: leadqueryparam, paramsSerializer: params => qs.stringify(params, { arrayFormat: "repeat" })},false)),
        dispatch(handleRequestGetInvoice({params: orderqueryparam, paramsSerializer: params => qs.stringify(params, { arrayFormat: "repeat" })})),
        dispatch(handleRequestGetOrder({params: invoicequeryparam, paramsSerializer: params => qs.stringify(params, { arrayFormat: "repeat" })}, false))
      ]);

      const reports = await handleGenearteRepprt(resolvedOwners, leadRes, invoiceRes, orderRes);

      const dataset = {
          labels: reports?.map(item => item?.username),
          datasets: [
            {
              label: handleValidateCodevalue(internationalise,"LEAD_SIDEBAR_MENU"),
              data: reports?.map(item => item?.totalLeads),
              backgroundColor: colorCode[0],
            },
            {
              label: handleValidateCodevalue(internationalise,"SALES_ORDER_SIDEBAR_MENU"),
              data: reports?.map(item => item?.totalOrders),
              backgroundColor: colorCode[1],
            },
            {
              label: handleValidateCodevalue(internationalise,"INVOICE_SIDEBAR_MENU"),
              data: reports?.map(item => item?.totalInvoices),
              backgroundColor: colorCode[2],
            },
          ],
        }

        setChartDataset(dataset);
        setIsLoading(false);
    
    } catch (err) {
      console.error("Error fetching data:", err);
      setIsLoading(false);
    
    }
  };

  if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
  }

  if(value && currentUser){
        fetchData();
  }
    
}, [value,currentUser])
        

  const userRef = useRef(null);

  const options = {
  // responsive: true,
  maintainAspectRatio : false,
  plugins: {
    legend: {
      position: 'top',
    },
    title: {
      display: false,
      text: '',
    },
  },
};

const showChartLoader = isLoading || isParentLoading;

if(showChartLoader) {
   return ( 
   <div className='piechartContainer' style={{display: "flex", alignItems: "center", justifyContent: "center", height: "100%"}}>
      <img
          src={LoaderIcon}
          alt="loading"
          style={{ width: 60, height: 60, animation: "spin 1.2s linear infinite" }}
        />
    </div>);
  } else {

  return (
    <div className='piechartContainer' style={{ display: "flex", flexDirection: "column", height: "100%" }}>      
          <ChartFilter 
              label={handleValidateCodevalue(internationalise, "CONF_MENU_USER")}
              onChange={onChange}
              value={value}
              isType="barChart"
          />
          <div style={{ position: "relative", flex: 1, minHeight: 0, width: "100%" }}>
              <Bar ref={userRef} options={options} data={chartDataset} />
          </div>
      </div>
  );

}
}
